import { useMemo } from 'react';

/**
 * useGetInBackground will dispatch a function returning a promise in the background
 * and return the resulting promise. It is up to the consumer to await or chain onto
 * the promise to do any sort of action after the fact. A new promise is returned when
 * dependencies change.
 *
 * BIG NOTE: Functions must be pure and cannot make any set state calls or any context
 * calls. These functions are called during the render loop, not after, so keep them
 * slim if possible.
 *
 *
 * @param dispatch the function returning a promise
 * @param deps any deps for creating new promises.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
function useGetInBackground<T>(dispatch: () => Promise<T>, deps: any[]): Promise<T> {
  return useMemo(dispatch, deps);
}

export default useGetInBackground;
